import type { SVGProps } from 'react';

type IconProps = SVGProps<SVGSVGElement> & {
  size?: number | string;
};

export function StoresIcon({ size = 12, ...props }: IconProps) {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.31563 0H1.74375C0.7875 0 0 0.7875 0 1.74375V5.31562C0 6.27187 0.7875 7.05938 1.74375 7.05938H5.31563C6.27188 7.05938 7.05938 6.27187 7.05938 5.31562V1.77187C7.0875 0.7875 6.3 0 5.31563 0ZM5.82188 5.34375C5.82188 5.625 5.59688 5.85 5.31563 5.85H1.74375C1.4625 5.85 1.2375 5.625 1.2375 5.34375V1.77187C1.2375 1.49062 1.4625 1.26562 1.74375 1.26562H5.31563C5.59688 1.26562 5.82188 1.49062 5.82188 1.77187V5.34375Z"
        fill="currentColor"
      />
      <path
        d="M14.6813 0H11.1095C10.1532 0 9.36572 0.7875 9.36572 1.74375V5.31562C9.36572 6.27187 10.1532 7.05938 11.1095 7.05938H14.6813C15.6376 7.05938 16.4251 6.27187 16.4251 5.31562V1.77187C16.4251 0.7875 15.6376 0 14.6813 0ZM15.1876 5.34375C15.1876 5.625 14.9626 5.85 14.6813 5.85H11.1095C10.8282 5.85 10.6032 5.625 10.6032 5.34375V1.77187C10.6032 1.49062 10.8282 1.26562 11.1095 1.26562H14.6813C14.9626 1.26562 15.1876 1.49062 15.1876 1.77187V5.34375Z"
        fill="currentColor"
      />
      <path
        d="M5.31563 8.97192H1.74375C0.7875 8.97192 0 9.75942 0 10.7157V14.2875C0 15.2438 0.7875 16.0313 1.74375 16.0313H5.31563C6.27188 16.0313 7.05938 15.2438 7.05938 14.2875V10.7438C7.0875 9.75942 6.3 8.97192 5.31563 8.97192ZM5.82188 14.3157C5.82188 14.5969 5.59688 14.8219 5.31563 14.8219H1.74375C1.4625 14.8219 1.2375 14.5969 1.2375 14.3157V10.7438C1.2375 10.4625 1.4625 10.2375 1.74375 10.2375H5.31563C5.59688 10.2375 5.82188 10.4625 5.82188 10.7438V14.3157Z"
        fill="currentColor"
      />
      <path
        d="M14.6813 8.97192H11.1095C10.1532 8.97192 9.36572 9.75942 9.36572 10.7157V14.2875C9.36572 15.2438 10.1532 16.0313 11.1095 16.0313H14.6813C15.6376 16.0313 16.4251 15.2438 16.4251 14.2875V10.7438C16.4251 9.75942 15.6376 8.97192 14.6813 8.97192ZM15.1876 14.3157C15.1876 14.5969 14.9626 14.8219 14.6813 14.8219H11.1095C10.8282 14.8219 10.6032 14.5969 10.6032 14.3157V10.7438C10.6032 10.4625 10.8282 10.2375 11.1095 10.2375H14.6813C14.9626 10.2375 15.1876 10.4625 15.1876 10.7438V14.3157Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function CreateOrderIcon({ size = 12, ...props }: IconProps) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.9999 9.7777V14.2221C15.9999 14.6936 15.8126 15.1458 15.4792 15.4792C15.1458 15.8126 14.6936 15.9999 14.2221 15.9999H1.77776C1.30627 15.9999 0.85409 15.8126 0.520695 15.4792C0.1873 15.1458 0 14.6936 0 14.2221V1.77776C0 1.30627 0.1873 0.85409 0.520695 0.520695C0.85409 0.1873 1.30627 0 1.77776 0H6.22217V1.77776H1.77776V14.2221H14.2221V9.7777H15.9999Z"
        fill="currentColor"
      />
      <path
        d="M16.0001 3.55553H12.4446V0H10.6669V3.55553H7.11133V5.33329H10.6669V8.88882H12.4446V5.33329H16.0001V3.55553Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function BillingIcon({ size = 12, ...props }: IconProps) {
  return (
    <svg
      width="19"
      height="16"
      viewBox="0 0 16 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.6 0C14.2365 0 14.847 0.252856 15.2971 0.702944C15.7471 1.15303 16 1.76348 16 2.4V10.4C16 11.0365 15.7471 11.647 15.2971 12.0971C14.847 12.5471 14.2365 12.8 13.6 12.8H2.4C1.76348 12.8 1.15303 12.5471 0.702944 12.0971C0.252856 11.647 0 11.0365 0 10.4V2.4C0 1.76348 0.252856 1.15303 0.702944 0.702944C1.15303 0.252856 1.76348 0 2.4 0H13.6ZM14.4 4.8H1.6V10.4C1.60003 10.5959 1.67196 10.7851 1.80217 10.9315C1.93238 11.0779 2.1118 11.1715 2.3064 11.1944L2.4 11.2H13.6C13.7959 11.2 13.9851 11.128 14.1315 10.9978C14.2779 10.8676 14.3715 10.6882 14.3944 10.4936L14.4 10.4V4.8ZM12 7.2C12.2039 7.20023 12.4 7.2783 12.5483 7.41828C12.6966 7.55825 12.7858 7.74956 12.7977 7.95312C12.8097 8.15667 12.7435 8.3571 12.6126 8.51347C12.4817 8.66983 12.2961 8.77032 12.0936 8.7944L12 8.8H9.6C9.3961 8.79977 9.19997 8.7217 9.05171 8.58172C8.90344 8.44175 8.81421 8.25044 8.80226 8.04688C8.79031 7.84333 8.85654 7.6429 8.98741 7.48653C9.11828 7.33017 9.30392 7.22968 9.5064 7.2056L9.6 7.2H12ZM13.6 1.6H2.4C2.18783 1.6 1.98434 1.68429 1.83431 1.83431C1.68429 1.98434 1.6 2.18783 1.6 2.4V3.2H14.4V2.4C14.4 2.18783 14.3157 1.98434 14.1657 1.83431C14.0157 1.68429 13.8122 1.6 13.6 1.6Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function NotificationIcon({ size = 12, ...props }: IconProps) {
  return (
    <svg
      width="17"
      height="20"
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.805 14.1935C16.3137 13.3011 15.5832 10.7762 15.5832 7.47847C15.5832 1.73012 9.68091 -1.8626 4.95904 1.01157C2.76762 2.34548 1.41764 4.81065 1.41764 7.47847C1.41764 10.7772 0.686341 13.3011 0.194968 14.1935C-0.354354 15.1866 0.322067 16.4343 1.41253 16.4393L1.41764 16.4393H5.03075C5.5766 19.2552 8.80917 20.3923 10.8494 18.4859C11.4233 17.9496 11.8166 17.2314 11.9701 16.4393H15.5832C16.6737 16.4377 17.3537 15.1922 16.8071 14.1973L16.805 14.1935ZM8.50044 17.9327C7.60021 17.9324 6.79785 17.3341 6.49778 16.4393H10.5031C10.203 17.3341 9.40067 17.9324 8.50044 17.9327ZM1.41764 14.9458C2.09936 13.71 2.8342 10.8462 2.8342 7.47847C2.8342 2.87979 7.55606 0.00560488 11.3336 2.30495C13.0867 3.37208 14.1667 5.34422 14.1667 7.47847C14.1667 10.8434 14.8998 13.7072 15.5832 14.9458H1.41764Z"
        fill="currentColor"
      />
    </svg>
  );
}
